// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"e82a8aff","341":"43045802","621":"d5b76cf4","647":"537ae2b3","811":"478bb558"}[chunkId] + ".chunk.js";
};